import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import "../../css/contact-form-page.css";
import { fetchContactFormInbox } from "../../services/messagingService";
import { getImage } from "../../utils/cloudinarySizing";

const ContactForms = () => {
    const [contacts, setContacts] = useState([]);
    const [loading, setLoading] = useState(true);

    const navigate = useNavigate();

    useEffect(() => {
        const loadInbox = async () => {
            try {
                const data = await fetchContactFormInbox();
                setContacts(data);
            } catch (err) {
                console.error(err);
            } finally {
                setLoading(false);
            }
        };
        loadInbox();
    }, []);

    const formatPhone = (value) => {
        if (!value) return "Not available";

        const digits = value.replace(/\D/g, "").substring(0, 10);
        const part1 = digits.substring(0, 3);
        const part2 = digits.substring(3, 6);
        const part3 = digits.substring(6, 10);

        if (digits.length > 6) return `(${part1}) ${part2}-${part3}`;
        if (digits.length > 3) return `(${part1}) ${part2}`;
        if (digits.length > 0) return `(${part1}`;
        return "Not available";
    };

    const handleSenderClick = (profileId) => {
        if (!profileId) return;
        navigate(`/profile/${profileId}`);
    };

    const getSenderImage = (item) => {
        return getImage(item.sender_photo_80, "avatar_xsm") || "/servspace-default-150x150.png";
    };

    const formatDateTime = (value) => {
        if (!value) return "";

        const date = new Date(value);

        const dateStr = date.toLocaleDateString(undefined, {
            year: "numeric",
            month: "short",
            day: "numeric",
        });

        const timeStr = date.toLocaleTimeString(undefined, {
            hour: "2-digit",
            minute: "2-digit",
            hour12: true,
        });

        return `${dateStr} at ${timeStr}`;
    };

    if (loading) return null;

    return (
        <div className="contact-forms-page">

            {!loading && contacts.length > 0 && (
                <p>Contact form submissions from users.</p>
            )}


            {!loading && contacts.length === 0 && (
                <div className="contact-forms-empty">
                    <i className="fa-regular fa-envelope-open" />
                    <h3>No contact form submissions yet</h3>
                    <p>When clients contact you, their forms will appear here.</p>
                </div>
            )}

            {!loading && contacts.length > 0 && (
                <div className="mailbox-list">
                    {contacts.map((item) => (
                        <div key={item.id} className="mailbox-card">
                            <div className="mailbox-card-left">
                                <img
                                    src={getSenderImage(item)}
                                    alt={item.sender_username || item.name}
                                    className="mailbox-sender-img"
                                    onClick={() => handleSenderClick(item.sender_profile_id)}
                                    style={{ cursor: "pointer" }}
                                    onError={(e) => {
                                        e.target.onerror = null;
                                        e.target.src = "/servspace-default-150x150.png";
                                    }}
                                />
                            </div>

                            <div className="mailbox-card-right">
                                <div className="mailbox-card-header">
                                    <div className="mailbox-sender">{item.name}</div>
                                    <div className="mailbox-date">{formatDateTime(item.created_at)}</div>
                                </div>

                                <div className="mailbox-meta">
                                    <span className="mailbox-context">
                                        {item.context === "freelancer"
                                            ? "Freelancer Inquiry"
                                            : "Business Inquiry"}
                                    </span>
                                    <span className="mailbox-email">
                                        <i className="fa-solid fa-envelope" /> {item.email}
                                    </span>
                                    <span className="mailbox-phone">
                                        <i className="fa-solid fa-phone" /> {formatPhone(item.phone)}
                                    </span>
                                </div>

                                <div className="mailbox-message">
                                    {item.message.length > 120
                                        ? item.message.slice(0, 120) + "…"
                                        : item.message}
                                </div>
                            </div>
                        </div>
                    ))}
                </div>
            )}
        </div>
    );
};

export default ContactForms;
